<template>
	<div class="inner">
		<p class="myusername">{{ login.user_name }}&emsp;さん</p>
		<div class="mymenu-blk">
			<div class="mymenu">
				<div class="mymenu-item">
					<router-link to="/mypage/"><div class="mymenu-icon"><fa icon="history" class="icon" /></div><div class="mymenu-title">申込履歴</div></router-link></div>
				<div class="mymenu-item">
					<router-link to="/mypage/news"><div class="mymenu-icon badge" :data-num="login.anketo"><fa icon="bell" class="icon fa-bell" /></div><div class="mymenu-title">お知らせ</div></router-link>
				</div>
				<div class="mymenu-item">
					<router-link to="/mypage/information"><div class="mymenu-icon"><fa icon="id-card" class="icon" /></div><div class="mymenu-title">ID情報</div></router-link>
				</div>
			</div>
			<div class="menu-item"><router-link to="/"><fa icon="reply" class="icon fa-reply fa-fw" />ボランティア検索へ</router-link></div>
		</div>
	</div>
</template>

<script>
import { inject } from 'vue';
export default {
	name: "MypageMenu",
	components: {
	},
	setup() {
		const { login } = inject('loginstate');

		return {
			login,
		}
	},
}
</script>

<style scoped>

.mymenu-blk {
    display: flex;
    justify-content: space-between;
	align-items: center;
}



.mymenu {
    display: flex;
	/* justify-content: space-between; */
	justify-content: space-around;
}


.myusername {
	margin: 0 0 8px;
}

.mymenu .mymenu-item {
    width: 110px;
    height: 60px;
    margin-right: 8px;
    border-radius: 5px;
    background: #fff;
    box-shadow: 0px 2px 2px #ababab;
	position: relative;
}
.mymenu .mymenu-item:hover {
	background: #e0e0e0;
}
.mymenu-blk .menu-item {
	text-decoration: underline;
	text-align: center;
	margin: 10px 0 0;
}
.mymenu-blk .menu-item a:hover {
	background: #e0e0e0;
}

.mymenu-icon {
	text-align: center;
	font-size: 2.6rem;
	height: 40px;
	line-height: 40px;
}

.mymenu-title {
	text-align: center;
	font-size: 1.4rem;
	height: 20px;
	line-height: 20px;
}

.fa-bell {
	position: relative;
}

/* .badge[data-num="0"]::before {
  display: none;
} */
.badge[data-num="false"]::before {
  display: none;
}
.badge::before {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
	/* 数字出すなら↓ */
    /* content: attr(data-num); */
	content: "";
	min-width: 12px;
    height: 12px;
    box-sizing: border-box;
    padding: 4px;
	font-size: 1rem;
    font-weight: bold;
    background-color: #ef5350;
    border: 1px solid #fff;
    border-radius: 10px;
    top: .3em;
    right: 3.5em;
    /* transform: translate(40%, -40%); */
    z-index: 1;
}

@media screen and (max-width:425px) {
.mymenu .mymenu-item {
    width: 100px;
	height: 50px;
	margin: 0;
}

.mymenu-blk {
    display: block;
}

.mymenu-icon {
	font-size: 2rem;
	height: 30px;
	line-height: 30px;
}

.mymenu-title {
	font-size: 1.2rem;
}

.badge::before {
    top: .2em;
    right: 3em;
}

}
/* .grid-blk {
    display: grid;
    width: 80%;
    height: 100px;
	margin: 0 auto;
    grid-template-columns: 33.33333% 33.33333% 33.33333%;
    grid-template-rows: 70% 30%;
    grid-template-areas: "a b c""d d d";
}

.grid-blk div {
	display: flex;
	align-items: center;
    justify-content: center;
}

.grid-blk .grid-a {
    grid-area: a;
}

.grid-blk .grid-b {
    grid-area: b;

}

.grid-blk .grid-c {
    grid-area: c;
}

.grid-blk .grid-d {
    grid-area: d;
} */
</style>